/**
 * This function will initialize the `AppleID.auth` object with parameter we pass in.
 */
$(document).ready(function(){
    state = {}
    if ($('.user').data().uuid) {
        state = { user_id: $('.user').data().uuid }
    }
    serialized_state = JSON.stringify(state)
    try {
        const data = window.AppleID.auth.init({
            clientId: $("head meta[name='appleid-signin-client-id']").attr('content'), // This is the service ID we created.
            scope: "name email", // To tell apple we want the user name and emails fields in the response it sends us.
            redirectURI: 'https://migration.lvh.me:3003',
            state: serialized_state,
            usePopup: true
        });
    } catch ( error ) {
        // Handle error.
    }

    // Listen for authorization success.
    document.addEventListener('AppleIDSignInOnSuccess', (event) => {
        console.log(event.detail.authorization.code)
        console.log(event.detail.authorization.id_token)
        console.log(event.detail.authorization.state)
        // Handle successful response.
    });

// Listen for authorization failures.
    document.addEventListener('AppleIDSignInOnFailure', (event) => {
        // Handle error.
        alert('bad')
        console.log('la...!!')
        console.log(event.detail.error);
    });
})